import React from "react";
import Icon from "@ant-design/icons";

const GiftSvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M3 10H2V18C2 18.5304 2.21071 19.0391 2.58579 19.4142C2.96086 19.7893 3.46957 20 4 20H9V10H3ZM16 10H11V20H16C16.5304 20 17.0391 19.7893 17.4142 19.4142C17.7893 19.0391 18 18.5304 18 18V10H16ZM16.791 5C16.9377 4.51378 17.0082 4.00779 17 3.5C17 1.57 15.43 0 13.5 0C11.878 0 10.795 1.482 10.096 3.085C9.407 1.57 8.269 0 6.5 0C4.57 0 3 1.57 3 3.5C3 4.096 3.079 4.589 3.209 5H0V9H9V7H11V9H20V5H16.791ZM5 3.5C5 2.673 5.673 2 6.5 2C7.388 2 8.214 3.525 8.698 5H6C5.626 5 5 5 5 3.5ZM13.5 2C14.327 2 15 2.673 15 3.5C15 5 14.374 5 14 5H11.523C12.033 3.424 12.774 2 13.5 2Z" />
  </svg>
);

const GiftIcon = (props) => <Icon component={GiftSvg} {...props} />;

export default GiftIcon;
